import { loadScript } from 'vue-plugin-load-script'
import store from '@/store'
import { getCookie, setCrossDomainCookie } from '@gto/helpers/cookies'

function trackAffiliate() {
  // GTO_trackAffil - identifier cookie
  // gtowizard.com/<affil> sets cookies GTO_trackAffil and GTO_<affil>Triggered
  // if user is logged in and has GTO_trackAffil and GTO_<affil>Triggered we track this to firebase and set GTO_<affil>Finished
  // so that firebase is not loaded needlesly

  // GTO_trackAffil default is yokosawa - he was first
  // but some people might not have this cookie since it was not built this way at first
  const trackAffil = getCookie('GTO_trackAffil') || 'yokosawa'
  if (!getCookie(`GTO_${trackAffil}Triggered`)) return // user did not start affil flow at all
  if (getCookie(`GTO_${trackAffil}Finished`)) return // user already finished affil flow

  loadScript('https://www.gstatic.com/firebasejs/10.10.0/firebase-app-compat.js').then(() => {
    loadScript('https://www.gstatic.com/firebasejs/10.10.0/firebase-analytics-compat.js').then(
      () => {
        loadScript('https://www.gstatic.com/firebasejs/10.10.0/firebase-database-compat.js').then(
          () => {
            // after yokosawa is done we'll use only the second conf (yokosawa was first)
            const firebaseConfig =
              trackAffil === 'yokosawa'
                ? {
                    apiKey: 'AIzaSyAMjDOXkvpf_I5mcYkF0_b-i3LUwI-cFGU',
                    authDomain: 'yokosawa-868af.firebaseapp.com',
                    databaseURL: 'yokosawa-868af-default-rtdb.europe-west1.firebasedatabase.app',
                    projectId: 'yokosawa-868af',
                    storageBucket: 'yokosawa-868af.appspot.com',
                    messagingSenderId: '751491379246',
                    appId: '1:751491379246:web:9e31c39881b5f605852fbf',
                    measurementId: 'G-2P30XHMB3J',
                  }
                : {
                    apiKey: 'AIzaSyBSoiHea-6oPl35MQzGVZswvM-nQA_dvfw',
                    authDomain: 'partners-7be44.firebaseapp.com',
                    databaseURL:
                      'https://partners-7be44-default-rtdb.europe-west1.firebasedatabase.app/',
                    projectId: 'partners-7be44',
                    storageBucket: 'partners-7be44.appspot.com',
                    messagingSenderId: '826179532563',
                    appId: '1:826179532563:web:8fc9171cd8eb95c11b8ce6',
                    measurementId: 'G-3BPEST0G96',
                  }

            const userId = store.getters.user_info.public_id
            const firebase = window.firebase
            if (!firebase) {
              // for sentry
              console.log('AFFILTRACK - userId', userId)
              console.error('AFFILTRACK - Firebase not loaded')
              return
            }

            const fb_app = firebase.initializeApp(firebaseConfig)
            firebase.database(fb_app)

            firebase.database().ref(`partner-data/${userId}`).push({
              affiliate_id: trackAffil,
              timestamp: firebase.database.ServerValue.TIMESTAMP,
            })
            setCrossDomainCookie(`GTO_${trackAffil}Finished`, 'true', 1095)
          },
        )
      },
    )
  })
}

export { trackAffiliate }
